module.exports = __webpack_public_path__ + "img/categorie-coffret-famille-boutrais-small.f20230de.jpg";